export default __webpack_public_path__ + "static/white-stylus-and-a-tablet-lay-on-a-dark-table-39c0b4df6ad540dca042987c4629469d.jpg";